import * as types from '../mutation-type'
// 弹窗设置
const state = {
  prompt_show: false,
  prompt_info: '',
  prompt_type_parem: ''
}

const getters = {
  prompt_show: state => state.prompt_show,
  prompt_info: state => state.prompt_info,
  prompt_type_parem: state => state.prompt_type_parem
}

const mutations = {
  [types.CHANGE_PROMPT_SHOW] (state, data) {
    state.prompt_show = data
  },
  [types.SET_PROMPT_INFO] (state, data) {
    state.prompt_info = data
  },
  [types.SET_PROMPT_TYPE_PARAM] (state, data) {
    state.prompt_type_parem = data
  }
}

const actions = {
  change_prompt_show ({commit}, param) {
    commit(types.CHANGE_PROMPT_SHOW, param)
  },
  set_prompt_info ({commit}, param) {
    commit(types.SET_PROMPT_INFO, param)
  },
  set_prompt_type_param ({commit}, param) {
    commit(types.SET_PROMPT_TYPE_PARAM, param)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/prompt.js